import StatisticsList from '../components/Statistics/StatisticsList';
import { DesktopWindows } from '@material-ui/icons';

export const Statistics = {
  icon: DesktopWindows,
  list: StatisticsList
};